import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import ViewShipment from './ViewShipment.js';
import Button from '../common/Button.js';

const ShipmentDetailModal = ({ shipmentId, onClose }) => {
  useEffect(() => {
    if (!shipmentId) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [shipmentId]);

  if (!shipmentId) return null;

  const handleBackdrop = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return createPortal(
    <div
      className="fixed inset-0 z-[90] bg-black/50 flex items-stretch sm:items-center justify-center sm:p-3 md:p-4 overflow-hidden"
      onClick={handleBackdrop}
      role="dialog"
      aria-modal="true"
      aria-label="Shipment details"
    >
      <div className="relative bg-gray-50 w-full min-h-0 h-[100dvh] max-h-[100dvh] sm:h-auto sm:max-h-[min(92vh,calc(100dvh-2rem))] sm:rounded-xl sm:max-w-5xl lg:max-w-6xl overflow-y-auto overscroll-contain flex flex-col shadow-none">
        <div className="sm:hidden sticky top-0 z-10 flex items-center justify-between px-3 py-2 pt-[max(0.5rem,env(safe-area-inset-top))] border-b border-gray-200 bg-white shrink-0">
          <p className="text-sm font-semibold text-gray-800 truncate pr-2">{shipmentId}</p>
          <Button variant="ghost" onClick={onClose} className="!p-1.5" aria-label="Close">
            <X className="w-5 h-5" />
          </Button>
        </div>
        <div className="pb-[max(1rem,env(safe-area-inset-bottom))]">
          <ViewShipment shipmentId={shipmentId} embedded onClose={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ShipmentDetailModal;
